import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import api from "@/lib/api";

const RBACCtx = createContext({ allowed: new Set(), modules: [], role: null, ready: false, refresh: () => {} });

export function RBACProvider({ children }) {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(new Set());
  const [modules, setModules] = useState([]);
  const [role, setRole] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setAllowed(new Set());
      setModules([]);
      setRole(null);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/rbac/me");
      setAllowed(new Set(data.allowed_modules || []));
      setModules(data.modules || []);
      setRole(data.role);
    } catch {
      setAllowed(new Set());
    } finally {
      setReady(true);
    }
  }, [user?.id, user?.impersonating?.actor_id]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <RBACCtx.Provider value={{ allowed, modules, role, ready, refresh, can: (k) => allowed.has(k) }}>
      {children}
    </RBACCtx.Provider>
  );
}

export const useRBAC = () => useContext(RBACCtx);
